import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../../init-store';
import { getParticipantsCount } from '../../selectors';

export const selectIsPipOpen = (state: RootState) => state.call.pip.isOpen;

export const selectPiPGridCurrentPage = (state: RootState) => state.call.pip.grid.currentPage;

export const selectPiPGridMaxDisplayParticipants = (state: RootState) => state.call.pip.grid.maxDisplayParticipants;

/**
 * Аналог `selectSlotsGridPageOffset` для PiP-сетки.
 * В PiP всегда GRID_VIEW.DEFAULT, поэтому `maxSlotsCount === maxDisplayParticipants`.
 */
export const selectPiPGridPageOffset = createSelector(
    [selectPiPGridMaxDisplayParticipants, selectPiPGridCurrentPage],
    (maxDisplayParticipants, currentPage) => maxDisplayParticipants * currentPage
);

/** Аналог `selectShowPrevSlotsPageButton` для PiP-сетки. */
export const selectShowPrevPiPGridPageButton = createSelector([selectPiPGridPageOffset], (offset) => offset > 0);

/**
 * Аналог `selectShowNextSlotsPageButton` для PiP-сетки.
 * Считаем по фактическому количеству участников и собственному `maxDisplayParticipants` PiP,
 * а не по `selectSlotsMaxOffset` (тот рассчитан под `maxSlotsCount` основного грида).
 */
export const selectShowNextPiPGridPageButton = createSelector(
    [selectPiPGridPageOffset, selectPiPGridMaxDisplayParticipants, getParticipantsCount],
    (offset, maxDisplayParticipants, participantsCount) => offset + maxDisplayParticipants < participantsCount
);

export const selectPiPCloseRequestId = (state: RootState) => state.call.pip.closeRequestId;
